<template>
  <el-select
    v-model="input"
    :remote-method="querySearch"
    placeholder="Enter name"
    multiple
    filterable
    remote
    class="w-100"
    size="small"
    clearable
    :disabled="disabled"
    :loading="isLoading"
    @clear="clearInput"
  >
    <el-option
      v-for="item in data"
      :key="item.id"
      :label="formatName(item)"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import Filter, { CONTAINS } from '@/plugins/sdk/Filter'
export default {
  name: 'ProfileAutoComplete',
  props: {
    value: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      input: '',
      data: [],
      isLoading: false
    }
  },
  created () {
    if (this.value.id) {
      this.input = this.value.name
    }
  },
  methods: {
    formatName (item) {
      return `${item.name} (${item.email})`
    },
    querySearch (queryString, cb) {
      this.isLoading = true
      this.$sdk.profile.list(builder => {
        builder.filters = [
          new Filter('name_full', CONTAINS, queryString),
          new Filter('email', CONTAINS, 'tigfreight.com')
        ]
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    getProfileId () {
      return this.input
    },
    clearInput () {
      this.input = ''
      this.$emit('input', {})
    }
  }
}
</script>

<style>

</style>
